// extracted by mini-css-extract-plugin
module.exports = {"container":"e_w8","title":"e_x8","image":"e_y8","mobileView":"e_z8"};